import type { Contact } from '~/interfaces/contacts/main';
import type { JsonApiResponse } from '~/interfaces/api/main';
import { useAuthFetchNext } from '~/composables/useAuthFetch.next';
import { isAPIErrorResponse } from '~/composables/useUtils';
import { createApiError, unwrapApiItem } from '~/api/utils';

export interface ContactsListResult {
  items: Contact[];
  totalItems: number;
}

export interface ContactDetailResult {
  item: Contact | null;
}

export const getContactsList = async (
  params?: string | null,
): Promise<ContactsListResult> => {
  const urlParams = params ? '?' + params : '';
  const response = await useAuthFetchNext(`contacts${urlParams}`);

  if (isAPIErrorResponse(response)) {
    throw createApiError('Impossible de récupérer les contacts', response.errors);
  }

  const payload = response as JsonApiResponse<Contact[]>;

  return {
    items: payload.data ?? [],
    totalItems: payload.meta?.totalItems ?? 0,
  };
};

export const getContactDetail = async (
  id: number | string,
): Promise<ContactDetailResult> => {
  const response = await useAuthFetchNext(`contact/view/${id}`);

  if (isAPIErrorResponse(response)) {
    throw createApiError('Impossible de récupérer le contact', response.errors);
  }

  return {
    item: unwrapApiItem<Contact>(response),
  };
};

export const deleteContactsBatch = async (
  contactsIds: number[],
): Promise<void> => {
  const response = await useAuthFetchNext('contacts', {
    method: 'DELETE',
    body: { ids: contactsIds },
  });

  if (isAPIErrorResponse(response)) {
    throw createApiError('Le contact n\'a pas pu être supprimé', response.errors);
  }
};
